import React from 'react'
import { Box, Container, makeStyles } from '@material-ui/core'
import Page from '../../../components/Page'
import Password from './Password'
import { DashboardLayout } from '../../../layouts/ClinicDashboardLayout'
import { ClinicStore } from '../../../../stores'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}))

const SettingsView = () => {
  const classes = useStyles()

  return (
    <ClinicStore.Provider>
      <DashboardLayout>
        <Page className={classes.root} title="Settings">
          <Container maxWidth="lg">
            <Box mt={3}>
              <Password />
            </Box>
          </Container>
        </Page>
      </DashboardLayout>
    </ClinicStore.Provider>
  )
}

export default SettingsView
